export default __webpack_public_path__ + "img/input-clear.svg";